import { endPoint } from './base.config';

export const voucherPayments = {
  fetchAll: endPoint + 'voucherPayments', // add to payment list to send to bank for payment width code
  save: endPoint + 'voucherPayments',
  update: endPoint + 'voucherPayments/:uuid',
  getByVoucherId: endPoint + 'voucherPayments/getByVoucherId',
  getByPaymentsUUID: endPoint + 'voucherPayments/get-by-payments-uuid',
  updateVoucherPaymentsStatus: endPoint + 'voucherPayments/update-voucher-payments-status',
  // saveList: endPoint + 'voucherPayments/save-list',
  checkAllowPayment: endPoint + 'voucherPayments/check-allow-payment',
  handleAfterCreateAsice: endPoint + 'voucherPayments/handle-after-create-asice',
  updateByPaymentsIds: endPoint + 'voucherPayments/update-by-paymentsIds',
  getStatistic: endPoint + 'voucherPayments/statistics',
  addUnpaidEhfVouchersToPaymentList: endPoint + 'voucherPayments/add-unpaid-ehf-vouchers-to-payment-list/:companyId',
  getPaymentActions: endPoint + 'voucherPayments/:companyId/get-payment-actions',
  editInternalTransfer: endPoint + 'v2/voucher-payments/:companyId/internal-transfer/:id',
  autoAddOldPayment: endPoint + 'voucherPayments/auto-add-old-payment',
};

export const voucherPaymentsV2 = {
  fetchAll: `${endPoint}v2/voucher-payments`,
  update: `${endPoint}v2/voucher-payments/:id`,
  payNow: `${endPoint}v2/voucher-payments/pay-now`,
  scaSuccess: endPoint + `v2/voucher-payments/:voucherPaymentIds/sca-success`,
  getStatistic: endPoint + 'v2/voucher-payments/statistics',
  addToPaymentList: endPoint + `v2/voucher-payments/add-to-paymentlist`,
  getByVoucherId: endPoint + 'v2/voucher-payments/get-by-voucherId',
  getByPaymentsUUID: endPoint + 'v2/voucher-payments/get-payment-info-by-uuid',
  delete: endPoint + `v2/voucher-payments/delete-list`,
  signing: endPoint + `v2/voucher-payments/:ids/signing`,
  addInternalTransfer: `${endPoint}v2/voucher-payments/internal-transfer`,
  editInternalTransfer: endPoint + 'v2/voucher-payments/internal-transfer/:id',
  exists: endPoint + `v2/voucher-payments/exists`,
  handleZtlScaCallback: endPoint + `v2/voucher-payments/:flowId/handle-ztl-sca-callback`,
  handleZtlCancelCallback: endPoint + `v2/voucher-payments/:flowId/handle-ztl-cancel-callback`,
  internaltionalPayNow: endPoint + `v2/voucher-payments/international-pay-now`,
  getLocalIbanInfo: endPoint + `v2/voucher-payments/local-iban-info`,
  cancelPayment: endPoint + `v2/voucher-payments/:id/cancel`,
  handleZtlSignCallback: endPoint + `v2/voucher-payments/:voucherPaymentIds/ztl-sign-callback`,
  addAdvancePayment: endPoint + `v2/voucher-payments/:companyId/advance-payment`,
  split: endPoint + `v2/voucher-payments/:id/split`,
};
